import { useState, useEffect } from 'react';
import { FILE_BASE_URL } from '../../../apiConfig';

function PlayingConditions() {
  const [isMobile, setIsMobile] = useState(false);
  const [pdfHeight, setPdfHeight] = useState('100vh');
  const [pdfWidth, setPdfWidth] = useState('100%');

  // Detect devices and set appropriate dimensions
  useEffect(() => {
    const checkDevice = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Set specific dimensions based on device type
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      
      if (isIOS) {
        // iOS-specific fix: use a fixed height that works better
        setPdfHeight('85vh');
        setPdfWidth('100%');
      } else if (mobile) {
        // Other mobile devices
        setPdfHeight('90vh');
        setPdfWidth('100%');
      } else {
        // Desktop - ensure full proper sizing
        setPdfHeight('100vh');
        setPdfWidth('100%');
      }
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  // Desktop styles with more generous padding and full width
  const desktopStyles = {
    padding: '0 6rem',
    maxWidth: '100%',
    paddingBottom: '2rem',
  };

  // Mobile styles with adjusted padding for smaller screens
  const mobileStyles = {
    padding: '0 1rem',
    maxWidth: '100%',
    paddingBottom: '2rem',
  };

   const btnstyles = {
            textDecoration: 'none',
            font: '400 16px var(--fontSSP)',
            color: 'var(--yellow)',
            background: 'var(--blue)',
            padding: '.4rem 3.2rem',
            borderRadius: '16px',
            marginTop: '24px',
            marginBottom: '24px',
        }

  

  return (
  <div
  className="pdf-container w-full"
  style={{
    ...(isMobile
      ? {
          border: '2px solid var(--yellow)', // Add a yellow border for mobile
          borderRadius: '12px', // Add rounded corners for mobile
          overflow: 'hidden', // Ensure content stays within the rounded border
        }
      : {}), // No border or radius for desktop
  }}
>
  <div
    id="PlayingConditions"
    className="tabcontent"
    style={isMobile ? mobileStyles : desktopStyles}
  >
    {/* PDF embed with object tag for better compatibility */}
    <object
      data={`${FILE_BASE_URL}/PLAYINGCONDITIONS.pdf`}
      type="application/pdf"
      className="w-full"
      style={{
        height: pdfHeight,
        width: pdfWidth,
      }}
    >
      <div className="pdf-fallback text-center p-4" style={{ textAlign: 'center', marginTop: '1rem' }}>
        <p className="mb-4">Sorry! Your browser doesn't support PDFs</p>
        <div style={{ textAlign: 'center', marginTop: '1rem' }}>
          <button
            style={btnstyles}
            onClick={() => window.open(`${FILE_BASE_URL}/PLAYINGCONDITIONS.pdf`, '_blank')}
            className="bg-blue-600 btn text-white py-2 px-4 rounded hover:bg-blue-700"
          >
            View Playing Conditions
          </button>
        </div>
      </div>
    </object>
  </div>
</div>
  );
}

export default PlayingConditions;